export default "__VITE_ASSET__BkoVcxAS__"